import api from '../utils/api'
import * as types from '../constants/ActionTypes'

let sendMailFinish = (response) => {
    return {
        type: types.SEND_MAIL_FINISH,
        payload: {},
        error: response.error
    }
}

let sendMail = (agentId, receiver, subject, content) => {
    var url = "/agents/sendMailToCustomer"
    var data = {agentId, receiver, subject, content}

    return dispatch => {
        return api(url).post(data)
            .then(agent => {
                if(agent.errCode==0){
                    dispatch(sendMailFinish({error: false}))
                }else {
                    dispatch(sendMailFinish({error: true}))
                }
            })
            .catch(err => {
                dispatch(sendMailFinish({error: true}))
            })
    }
}

let sendSMSSFinish = (response, callback) => {
    if (callback) {
        callback(response.error)
    }
    return {
        type: types.SEND_SMSS_FINISH,
        payload: {},
        error: response.error
    }
}

let sendSMSS = (agentId, phone, content, agent, datas, callback) => {
    const url = '/lossAss/cpic/sms';
    const data = datas;

    return dispatch => {
        return api(url).post(data)
            .then(agent => {
                if(agent.errCode == 0 ) {
                    dispatch(sendSMSSFinish({error: false}, callback))
                }else {
                    dispatch(sendSMSSFinish({error: true}, callback))
                }

            })
            .catch(err => {
                dispatch(sendSMSSFinish({error: true}))
            })
    }
}

export default {
    sendMail,
    sendSMSS
}
